import { render } from "./EventFrame.vue?vue&type=template&id=a8c19346&scoped=true"
import script from "./EventFrame.vue?vue&type=script&lang=js"
export * from "./EventFrame.vue?vue&type=script&lang=js"

import "./EventFrame.vue?vue&type=style&index=0&id=a8c19346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c19346"]])

export default __exports__